import { SurfaceWidget } from './SurfaceWidget';
import styled from '@emotion/styled';
import * as React from 'react';
import { DOCS_RAIL_BOTTOM_GAP, DOCS_RAIL_STICKY_TOP } from '../vars';
import { SCROLL } from './scroll';

export interface RailSurfaceWidgetProps {
  children?: React.ReactNode;
  className?: string;
  label?: React.ReactNode;
}

export const RailSurfaceWidget: React.FC<RailSurfaceWidgetProps> = (props) => {
  return (
    <S.Card className={props.className}>
      <S.ScrollArea>
        {props.label ? <S.Label>{props.label}</S.Label> : null}
        {props.children}
      </S.ScrollArea>
    </S.Card>
  );
};

namespace S {
  const RAIL_VIEWPORT_GUTTER = DOCS_RAIL_STICKY_TOP + DOCS_RAIL_BOTTOM_GAP;

  export const Card = styled(SurfaceWidget)`
    box-sizing: border-box;
    max-height: calc(100dvh - ${(p) => p.theme.header.height}px - ${RAIL_VIEWPORT_GUTTER}px);
    overflow: hidden;
    ${(p) => SCROLL(p.theme, true)};
  `;

  export const ScrollArea = styled.div`
    box-sizing: border-box;
    padding: 20px 16px 28px 18px;
    max-height: calc(100dvh - ${(p) => p.theme.header.height}px - ${RAIL_VIEWPORT_GUTTER}px);
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-gutter: stable;
    ${(p) => SCROLL(p.theme, true)};
  `;

  export const Label = styled.div`
    font-family: 'Inter Tight Variable', sans-serif;
    font-size: var(--rail-label-font-size, 13px);
    text-transform: uppercase;
    letter-spacing: 0.12em;
    color: ${(p) => p.theme.text.paragraph};
    opacity: 0.7;
    margin-bottom: 14px;
  `;
}
